var Controller = require('controllers/base/controller');
var PageView = require('views/page/page-view');
var PageService = require('services/page-service');
import { SessionStorageService } from 'services/web-storage-service';
var LocaleService = require('services/locale-service');
import ef from 'ef/ef';

var PageController = Controller.extend({
  show: function (params, route, options) {
    if (params.module && !isNaN(parseInt(params.module.charAt(0)))) {
      // eslint-disable-next-line no-console
      console.warn(
        'Module names cannot begin with a number. Rename the module such that the first character is not a number'
      );
    }
    PageService.loadPage(params.module, params.activity, params.page).then(page => {
      SessionStorageService.setItem('queryParams', options.query);
      if (PageService.preventSkippingPages(page, params)) {
        let linkedPage = page.get('link');
        let previouslyCompleted = page.get('completed') ? 'previously-completed' : '';
        let userSpecifiedClass = page.get('class') || '';
        let className = linkedPage
          ? `${linkedPage.page} ${linkedPage.activity} ${
              linkedPage.module
            } ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}`
          : `${page.get('key')} ${page.get('activityKey')} ${page.get(
              'moduleKey'
            )} ${previouslyCompleted} ${userSpecifiedClass} ${LocaleService.getLanguage()}`;

        if (page.get('transition') && !page.get('transition-in')) {
          //console.log(`rendering ${page.get('key')} without transition-in; setting transition-in to ${page.get('transition-in')}`);
          page.set('transition-in', 'forward');
        }

        if (Object.isExtensible(this)) {
          this.view = new PageView({
            region: 'main',
            model: page,
            className: className,
          });

          if (ef.forge_mode) {
            window.forge_data = window.forge_data || {};
            window.forge_data.controller = this;
            window.forge_data.pageView = this.view;
            window.forge_data.pageClassName = className;
          }
          //TODO: revisit trying to reuse the actionbarview, was moved to the page-view.play
          //this.reuse('actionbar', ActionBarView, {region: 'actionbar'});
          this.view.play();
        } else {
          return;
        }
      }
    });
  },
});

module.exports = PageController;
